const theme = {
  palette: {
    black: {
      highEmphasis: "rgba(0, 0, 0, 0.87)",
      mediumEmphasis: "rgba(0, 0, 0, 0.6)",
      lowEmphasis: "#808285",
      disabled: "#9E9E9E",
      inactive: "rgba(0, 0, 0, 0.54)"
    },
    blues: {
      lightestBlue: "#D1DCE5",
      lighterBlue: "#C5D3DF",
      lightBlue: "#647EA1",
      mainBlue: "#375A88"
    },
    texts: {
      tooltip: "#444444",
      dropdownSelected: "#375B88",
      placeholderSearch: "#9B9EA8",
      label: "#666766"
    },
    greys: {
      grey1: "#F9F9F9",
      grey2: "#F2F2F2",
      grey3: "#EBEBEB",
      grey4: "#C7C7C7",
      grey5: "#515151",
      grey6: "#373839"
    },
    primary: {
      main: "#81B194",
      contrastText: "white",
      50: "#E3EFFD"
    },
    secondary: {
      main: "#DD3100"
    },
    success: {
      dark: "#18AB00",
      lightest: "#F7FFFA",
      main: "#81B194"
    },
    error: {
      main: "#DD3100",
      lightest: "#FFF7F5",
      dark: "#B91919"
    },
    text: {
      primary: "#373839",
      disabled: "#9E9E9E"
    }
  },
  typography: {
    fontFamily: "'Myriad W01 Regular', Arial, Helvetica, sans-serif",
    h1: {
      color: "#375A88",
      fontSize: 36,
      fontWeight: 600
    },
    h2: {
      color: "#375A88",
      fontSize: 32,
      fontWeight: 600
    },
    h3: {
      color: "#375A88",
      fontSize: 28,
      fontWeight: 600
    },
    h4: {
      color: "#375A88",
      fontSize: 24,
      fontWeight: 600
    },
    h5: {
      color: "#375A88",
      fontSize: 20,
      fontWeight: 600
    },
    body1: {
      color: "#373839",
      fontSize: 14
    },
    subtitle1: {
      color: "#767B8E",
      fontSize: 14
    },
    subtitle2: {
      color: "#767B8E",
      fontSize: 14,
      fontWeight: 600
    },
    button: {
      fontFamily: "'Myriad W01 Bd', Arial, Helvetica, sans-serif",
      textTransform: 'none' as 'none',
      fontSize: 16,
    }
  },
  overrides: {
    MuiButton: {
      root: {
        color: "#375A88",
        borderRadius: 2,
        minHeight: 34,
        padding: "2px 12px",
        '&$disabled': {
          color: "#C7C7C7"
        }
      },
      contained: {
        backgroundColor: "#375A88",
        boxShadow: "none",
        color: "white",
        '&$disabled': {
          color: "white",
          backgroundColor: "#C7C7C7"
        }
      },
      outlined: {
        borderColor: "#375A88",
        backgroundColor: "transparent",
        padding: "2px 12px",
        '&$disabled': {
          color: "#C7C7C7",
          borderColor: "#C7C7C7"
        }
      },
      outlinedPrimary: {
        borderColor: "#81B194"
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.25)"
      }
    },
    MuiSelect: {
      root: {
        backgroundColor: "#F2F2F2",
        "&$disabled": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        }
      },
      icon: {
        color: "#515151",
        "&$disabled": {
          color: "#9E9E9E"
        }
      }
    },
    MuiCheckbox: {
      root: {
        color: "#365B88",
        padding: "0 6px",
        "&$checked": {
          color: "#365B88"
        },
        "&$disabled" : {
          color: "#E5E5E5",
          "& .MuiIconButton-label": {
            position: "relative",
            zIndex: 0,
          },
          "&:not($checked) .MuiIconButton-label:after": {
            content: '""',
            left: 4,
            top: 4,
            height: 15,
            width: 15,
            position: "absolute",
            backgroundColor: "#E5E5E5",
            zIndex: -1,
          },
        },
      },
      colorSecondary: {
        color: "#365B88",
        "&$checked": {
          color: "#365B88",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          }
        },
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        }
      },
    },
    MuiRadio: {
      root: {
        color: "#365B88",
        "&$checked": {
          color: "#365B88"
        },
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        }
      },
      colorSecondary: {
        color: "#365B88",
        "&$checked": {
          color: "#365B88",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          }
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          borderColor: "#365B88"
        },
        "&$focused $error": {
          borderColor: "#b91919"
        }
      }
    }
  },
};

  export default theme;
